import React, { useEffect, useState } from "react";
import totalTimg from "../../images/revenue.png";
import openTimg from "../../images/price-list.png";
import closeTimg from "../../images/box.png";
import riseTimg from "../../images/astranaut.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AcceptTicket from "./accept_ticket";
import SolveTicket from "./solve_ticket";
import { HiTicket } from "react-icons/hi2";

function TechieDashboard(props) {
  const [tickets, setTickets] = useState([]);
  const [accept, setAccept] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showSolve, setShowSolve] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getTicketsData = async () => {
      try {
        const response = await axios.get(
          `https://api.dectwinservices.com/api/techie-tickets/${props.clientData.id}/${props.clientData.company_id}`
        );
        setTickets(response.data);
        localStorage.setItem("tickets", JSON.stringify(response.data));
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    // const fetchCompany = async () => {
    //   const myComp = await axios.get(
    //     `https://api.dectwinservices.com/api/user-comp/${props.clientData.assign_comp}`
    //   );
    //   if (myComp.length < 1) {
    //     return;
    //   }
    //   setCompany(myComp.data[0]);
    // };
    // fetchCompany();
    getTicketsData();
  }, [props]);

  function openTickets() {
    const filtr = tickets.filter((elm) => elm.status === "Open");
    return filtr.length;
  }

  function closeTickets(id) {
    const filtr = tickets.filter(
      (elm) => elm.assigned_to === id && elm.status === "Closed"
    );
    return filtr.length;
  }

    function removeSeconds(dateTime) {
  return dateTime.slice(0, 16);
}

  return (
    <section className="px-32">
      <p className="fw-bolder fs-bigger">
        &nbsp;{props.clientData.company_name ?? "Welcome to Technician Panel"}
      </p>
      <div className="row px-2">

        <div className="col-lg-3 col-md-6 my-1">

        <div
        onClick={() => navigate('/techie/tickets')}
          style={{
            background:
              "linear-gradient(90deg, rgb(255, 136, 114), rgb(255, 112, 150))",
          }}
          className="dash-container"
        >
          <h3>
            Total Tickets <br />
            <br />{" "}
            <p className="fs-bigger">
              {openTickets() + closeTickets(props.clientData.id)}
            </p>
          </h3>
          <img src={totalTimg} alt="Total Pic" style={{height: '6em'}} />
        </div>
</div>

        <div className="col-lg-3 col-md-6 my-1">
        <div
        onClick={() => navigate('/techie/tickets')}
          style={{
            background:
              "linear-gradient(90deg, rgb(50, 201, 193), rgb(25, 170, 203))",
          }}
          className="dash-container"
        >
          <h3>
            Open Tickets <br />
            <br /> <p className="fs-bigger">{openTickets()}</p>
          </h3>
          <img src={openTimg} alt="Open Pic" style={{height: '6em'}}/>
           {/* <HiTicket size={100} /> */}
        </div>
        </div>



        <div className="col-lg-3 col-md-6 my-1">
        <div
        onClick={() => navigate('/techie/view-reports')}
          style={{
            background:
              "linear-gradient(90deg, rgb(129, 112, 255), rgb(233, 114, 255))",
          }}
          className="dash-container"
        >
          <h3>
            Solved Tickets <br />
            <br />
            <p className="fs-bigger">{closeTickets(props.clientData.id)}</p>
          </h3>
          <img src={closeTimg} alt="Closed Pic" style={{height: '6em'}} />
        </div>
        </div>

                <div className="col-lg-3 col-md-6 my-1">

        <div
     onClick={() => navigate('/techie/tickets')}   
          style={{
            textDecoration: "none",
            color: "black",
            background:
              "linear-gradient(90deg, rgb(88, 160, 223), rgb(128, 132, 235))",
          }}
          className="dash-container"
        >
          <h3>
            View All
            <br />
            <br /> <p className="fs-bigger">Tickets</p>
          </h3>
          <img src={riseTimg} alt="Total Pic" style={{height: '6em'}} />
        </div>
        </div>
      </div>
      <p style={{ margin: "16px 0" }} className="fw-bolder fs-bigger">
        &nbsp;Recent Tickets
      </p>
               <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
          <thead className="p-3 bg-grey text-center">
              <th className="p-2">Issue</th>
              <th className="p-2">Category</th>
              <th className="p-2">Priority</th>
              <th className="p-2">Create Date</th>
              <th className="p-2">Solve Date</th>
              <th className="p-2">Status</th>
              <th className="p-2 text-center">
                <i className="bx bxs-cog rounded-circle bg-grey p-0"></i>
              </th>
          </thead>
              {tickets.slice(0, 5).map((tkt, index) => (
                <tr key={index} className="text-center">
<th className="p-2">
  <div className="line-clamp-2">{tkt.title}</div>
</th>
                  <th className="p-2">{tkt.category}</th>
                  <th className="p-2"

                  >
                   <span    style={{
                      // flex: "0.4",
                      backgroundColor: tkt.status != 'Closed' ?
                        tkt.urgency == "1"
                          ? "#FF4C4C"
                          : tkt.urgency == "2"
                            ? "#FFD700"
                            : "#4CAF50"
                            : 'white',
                      color: tkt.status != 'Closed' ? "#fff" : 'black',
                      borderRadius: "4px"
                    }}>  {tkt.urgency == "1"
                      ? "Priority 1"
                      : tkt.urgency == "2"
                        ? "Priority 2"
                        : "Priority 3"}
              </span>    </th>    
           <th className="p-2">{removeSeconds(tkt.create_date)}</th>
                  <th className="p-2">{tkt.solve_date ? removeSeconds(tkt.solve_date) : "Pending"}</th>
                  <th className="p-2">{tkt.status}</th>
                  {tkt.status === "Closed" ? (
                    <th
                     className="p-2"
                      style={{
                        display: "flex",
                        // flex: "0.6",
                        justifyContent: "center",
                      }}
                    >
                      <button className="add-btn">Solved</button>
                    </th>
                  ) : (
                    <th
                      style={{
                        display: "flex",
                        flex: "0.7",
                        justifyContent: "center",
                      }}
                    >
                      {tkt.assigned_to === null ? (
                        <button
                          style={{ fontSize: "0.8rem" }}
                          className="add-btn"
                          onClick={() => {
                            setAccept(tkt);
                            setShowPopup(true);
                          }}
                        >
                          Accept
                        </button>
                      ) : (
                        <button
                          className="add-btn"
                          style={{ fontSize: "0.8rem" }}
                          onClick={() => {
                            setAccept(tkt);
                            setShowSolve(true);
                          }}
                        >
                          Mark Solved
                        </button>
                      )}
                    </th>
                  )}
                </tr>
              ))}
          </table>
      </div>
      {showPopup && (
        <AcceptTicket
          onClose={() => setShowPopup(false)}
          ticket={accept}
          tech_id={props.clientData.id}
          handleToast={props.handleToast}
        />
      )}
      {showSolve && (
        <SolveTicket
          onClose={() => setShowSolve(false)}
          ticket={accept}
          tech_id={props.clientData.id}
          handleToast={props.handleToast}
        />
      )}
    </section>
  );
}

export default TechieDashboard;
